/**
 * Created by rd_haiying_zheng on 2017/11/21.
 */
import { extend, isPlainObject } from 'tool'

class Jsonp {
	constructor(opts) {
		if (!isPlainObject(opts)) {
			throw new TypeError('The type of opts must be plainObject')
		}

		const defaultOps = {
			url: '',
			data: {},
			callbackName: 'callback',
			timeout: 60,
			onSuccess: null,
			onError: null,
			onComplete: null
		}

		!opts.data && (opts.data = {})
		if (!isPlainObject(opts.data)) {
			throw new TypeError('The type of opts.data must be plainObject')
		}

		if (!opts.url) {
			throw new TypeError('The url is required')
		}

		if (typeof opts.timeout !== 'number' || parseInt(Math.abs(opts.timeout)) <= 0) {
			opts.timeout = 60
		}

		if (typeof opts.callbackName !== 'string') {
			this.callbackName = 'callback'
		}

		this._$body = document.body || document.getElementsByTagName('body')[0]
		this._opts = extend(defaultOps, opts)
		this._execute = false

		this._init()
	}

	_init() {
		this._setParams()

		const $script = document.createElement('script')
		$script.setAttribute('type', 'text/javascript')

		let cbName = 'jsonp_' + new Date().getTime(),
			timer,
			params = [],
			data = this._opts.data

		for (const i in data) {
			if (data.hasOwnProperty(i)) {
				params.push(i + '=' + data[i])
			}
		}

		params.push(this._opts.callbackName + '=' + cbName)
		params = params.join('&')

		const complete = () => {
			typeof this._opts.onComplete === 'function' && this._opts.onComplete()
			this._$body.removeChild($script)
			$script.onerror = null
			timer && clearTimeout(timer)
			window[cbName] = null
			this._execute = true
		}
		const error = () => {
			if (this._execute) {
				return
			}

			typeof this._opts.onError === 'function' && this._opts.onError()
			complete()
		}

		window[cbName] = data => {
			if (this._execute) {
				return
			}

			try {
				data = JSON.parse(data)
			} catch (e) {
				//
			}

			typeof this._opts.onSuccess === 'function' && this._opts.onSuccess(data)
			complete()
		}

		// 浏览器不一定支持script的onerror事件，因此增加一个定时器，超过限定时间则默认请求失败
		$script.onerror = error
		timer = setTimeout(error, this._opts.timeout * 1000)

		$script.src = this._opts.url + '?' + params
		this._$body.appendChild($script)
	}

	_setParams() {
		const url = this._opts.url
		const obj = {}

		if (url.includes('?')) {
			const arr = url.split('?')
			const params = arr[1].split('&')

			this._opts.url = arr[0]

			params.forEach(item => {
				item = item.split('=')
				obj[item[0]] = item[1]
			})

			this._opts.data = extend({}, obj, this._opts.data)
		}
	}
}

/**
 * @param opts
 */
export default function (opts) {
	new Jsonp(opts)
}
